var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 1.1875C7.76844 1.18954 6.10838 1.87831 4.88397 3.10272C3.65957 4.32712 2.9708 5.98718 2.96876 7.71875C2.96668 9.13379 3.4289 10.5104 4.28451 11.6375C4.28451 11.6375 4.46263 11.872 4.49173 11.9059L9.50001 17.8125L14.5107 11.9029C14.5368 11.8714 14.7155 11.6375 14.7155 11.6375L14.7161 11.6357C15.5713 10.5091 16.0333 9.13314 16.0313 7.71875C16.0292 5.98718 15.3404 4.32712 14.116 3.10272C12.8916 1.87831 11.2316 1.18954 9.50001 1.1875ZM9.50001 10.0938C9.03028 10.0938 8.57109 9.95446 8.18053 9.69349C7.78996 9.43252 7.48555 9.0616 7.30579 8.62762C7.12603 8.19365 7.079 7.71612 7.17064 7.25541C7.26228 6.79471 7.48848 6.37152 7.82063 6.03937C8.15278 5.70722 8.57596 5.48102 9.03667 5.38938C9.49737 5.29774 9.97491 5.34478 10.4089 5.52454C10.8429 5.70429 11.2138 6.0087 11.4747 6.39927C11.7357 6.78984 11.875 7.24902 11.875 7.71875C11.8742 8.3484 11.6237 8.95203 11.1785 9.39726C10.7333 9.84249 10.1297 10.093 9.50001 10.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e0efe1aaa9627ded013247b770828687.svg";
export { ForwardRef as ReactComponent };